import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { WaitlistModalProvider } from './context/WaitlistModalContext';
import PopupForm from './components/PopupForm';

import Home from './pages/Home';
import About from './pages/About';
import Features from './pages/Features';
import Waitlist from './pages/Waitlist';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import BlogIndex from './pages/blog/BlogIndex';
import DoDoormatsKillBacteria from './pages/blog/posts/DoDoormatsKillBacteria';
import SmartVsTraditionalDoormat from './pages/blog/posts/SmartVsTraditionalDoormat';
import UvVsSprayDisinfection from './pages/blog/posts/UvVsSprayDisinfection';
import EntrywayHygieneHospitalsChildcare from './pages/blog/posts/EntrywayHygieneHospitalsChildcare';
import SmartDoormatBuyersGuideAustralia from './pages/blog/posts/SmartDoormatBuyersGuideAustralia';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="w-full min-h-screen bg-[#050505]">
      <HelmetProvider>
        <BrowserRouter>
          <WaitlistModalProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/features" element={<Features />} />
              <Route path="/waitlist" element={<Waitlist />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/do-doormats-kill-bacteria" element={<DoDoormatsKillBacteria />} />
              <Route path="/blog/smart-vs-traditional-doormat" element={<SmartVsTraditionalDoormat />} />
              <Route path="/blog/uv-vs-spray-disinfection" element={<UvVsSprayDisinfection />} />
              <Route path="/blog/entryway-hygiene-hospitals-childcare" element={<EntrywayHygieneHospitalsChildcare />} />
              <Route path="/blog/smart-doormat-buyers-guide-australia" element={<SmartDoormatBuyersGuideAustralia />} />
            </Routes>
            <PopupForm />
          </WaitlistModalProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
